import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

import reservation from './modules/reservation'

import * as types from './mutation-types'
import api from '@/api'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  isLoggedIn: false,
  user: {
    isStaff: false,
    isSuperuser: false,
    shop: null,
    pk: null,
    email: null,
  },
  selectedShop: null,
  shopData: {
    pk: null,
    name: null,
  },
  staff: null,
}

const mutations = {
  [types.LOGGED_IN] (state, data) {
    state.isLoggedIn = true
    Object.assign(state.user, data)
    state.user.shop = data.shopBase
  },
  [types.LOGGED_OUT] (state) {
    state.isLoggedIn = false
  },
  [types.SET_SHOP] (state, data) {
    state.shopData = data
  },
  STAFF_LOGGED_IN (state, data) {
    state.staff = data
  },
}

const actions = {
  login ({commit}, [username, password, saveToken]) {
    return api.auth.login(username, password).then(res => {
      commit(types.LOGGED_IN, res.body)
      let token = res.body.token
      api.setToken(token)
      if (saveToken) {
        localStorage.setItem('token', token)
      }
      return res
    }).then(res => {
      return api.accounts.profile().then(res => {
        commit(types.LOGGED_IN, res.body)
        return res
      })
    })
  },
  tryLoggedIn ({commit}) {
    let token = localStorage.getItem('token')
    if (token) {
      api.setToken(token)
    }
    return api.accounts.profile().then(res => {
      commit(types.LOGGED_IN, res.body)
      return res
    })
  },
  logout ({commit}) {
    localStorage.clear()
    commit(types.LOGGED_OUT)
  },
  setShop ({commit}, data) {
    commit(types.SET_SHOP, data)
  },
  staffLogin ({commit}, [code, password]) {
    return api.auth.staffLogin(code, password).then(res => {
      commit('STAFF_LOGGED_IN', res.body)
      api.setStaffToken(res.body.token)
      return res.body
    })
  },
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  isStaffLoggedIn: ({staff}) => Boolean(staff),
  superuserLoggedIn: ({user}) => user && user.isSuperuser,
  // NOTE: 店長以上の権限
  hasManagerAuthority: ({staff, user}) => {
    if (user && user.isSuperuser) return true
    if (!staff) return false
    let role = staff.role
    return role === 10 || role === 20
  },
  // NOTE: 管理者以上の権限
  adminLoggedIn: ({staff, user}) => {
    if (user && user.isSuperuser) return true
    if (!staff) return false
    let role = staff.role
    return role === 20
  },
  isStaff: state => state.user.isStaff,
  account: state => state.user,
  shop: state => {
    return (state.selectedShop || state.user.shop)
  },
  shopData: state => state.shopData,
}

export default new Vuex.Store({
  strict: debug,
  actions,
  getters,
  mutations,
  state,
  modules: {
    reservation,
  },
//  plugins: [createPersistedState()],
})



// WEBPACK FOOTER //
// ./src/store/index.js